import { services } from "../data/services";
import { citiesByProvince } from "../data/cities";
import { getHead } from "../seo/routes";
import { serviceIntro, serviceFaqs } from "../seo/content";
import { Seo } from "../components/Seo";
import { PageHero, Prose, FAQBlock, CTABand, Breadcrumbs, LinkGrid, SectionHead } from "../components/Blocks";
import { CheckCircle2 } from "lucide-react";

export default function ServiceProvincePage({ service, province }) {
  const path = `/${service.slug}-in-${province.slug}`;
  const faqs = serviceFaqs(service);
  const head = getHead(path, { service, faqs });
  const pCities = citiesByProvince(province.slug);
  return (
    <>
      <Seo title={head.title} description={head.description} path={path} />
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: service.name, to: `/services/${service.slug}` }, { label: province.name }]} />
      <PageHero
        overline={`${service.name} · ${province.name}`}
        title={`${service.name} in ${province.name}`}
        lead={service.short}
        image={service.image}
      />
      <Prose paragraphs={[serviceIntro(service), province.note, `From ${pCities[0].name} to ${pCities[pCities.length - 1].name}, our ${province.name} teams deliver ${service.name.toLowerCase()} with 24/7 dispatch support and time-stamped digital reporting on every shift. Call +1 807 907-2874 or email info@mazesecurity.ca to scope your coverage.`]} />
      <section className="bg-[#131620] border-y border-white/10" data-testid="serviceprovince-deliverables">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <SectionHead overline="Scope of Work" title={`${service.name} in ${province.name} — What's Included`} />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {service.deliverables.map((d) => (
              <div key={d} className="flex items-start gap-3 border border-white/10 bg-[#0D0E12] p-4 rounded-sm">
                <CheckCircle2 className="h-5 w-5 text-[#FF5500] shrink-0 mt-0.5" />
                <span className="text-sm text-gray-300 leading-relaxed">{d}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
      <LinkGrid
        overline="Local Pages"
        title={`${service.name} by City — ${province.name}`}
        items={pCities.map((c) => ({ to: `/${service.slug}-in-${c.slug}`, label: c.name, testid: `sp-city-${c.slug}` }))}
      />
      <FAQBlock faqs={faqs} heading={`${service.name} in ${province.name} — FAQs`} />
      <CTABand title={`Deploy ${service.name} Across ${province.name}`} sub="One call coordinates coverage in every city on this page. Urgent needs can often start the same day." />
    </>
  );
}
